import authenticate from "@/auth/authenticate";

export default [
  {
    path: "/account",
    name: "account",
    component: () => import("@/views/global/Clear"),
    beforeEnter: authenticate,
    children: [
      {
        path: "webauthn",
        name: "account.webauthn",
        component: () => import("@/views/account/WebAuthnRegister"),
      },
    ],
  },
];
